import HorizontalCarousel from '@component/carousel/src/views/HorizontalCarousel';
import { ScrollType } from '@component/carousel/src/views/Carousel';

export default class ColorSwatchesCarousel extends HorizontalCarousel {
  constructor(opts) {
    // Call parent class constructor
    super(opts);
    if (opts.swatchesWidth) {
      this.resizeEventListener = this.resizeEventListener.bind(this);
    }
  }

  /**
   * [EVENT LOGIC]
   * cancel swipeEventListener for color swatches into prosPanel
   * @param { EVENT } event
   */
  pointerMoveEventListener() {}

  /**
   *  doSizing is resize height of the carousel
   *  @todo should change after fix carousel dependency issue
   *  in run time parent dependency is been taken from product-thumbails node_modules
   *  which differ from this implementation and don't properly calc the wrapper width
   */
  doSizing() {
    if (this.childrenView.length === 0) {
      return;
    }

    this.reCalcWrapperAndChildrenWidth(this.opts.swatchesWidth, this.opts.swatchesButtonWidth);
  }

  reCalcWrapperAndChildrenWidth(swatchesWidth, buttonWidth) {
    const { childWidth } = this.childSize;
    const offsetWidth = swatchesWidth || this.el.offsetWidth;

    // get integer value of carousel Wrapper height
    const carouselWrapperWidth = offsetWidth - (2 * buttonWidth);

    // set carousel wrapper width again
    this.carouselWrapper.style.width = `${carouselWrapperWidth}px`;

    // calculate minimum number of child view that can fit in one page (with margin)
    let childPerPage = Math.floor(carouselWrapperWidth / childWidth);

    // see if there is empty space in the page at the end with minimum number of child view
    const extraChild = Math.floor(carouselWrapperWidth - (childWidth * childPerPage));

    // get Readonly computed style of each child
    const { marginRight, paddingRight } = getComputedStyle(this.childrenView[0]);

    // see if one more child can fit at the end if we do not count margin bottom of last child
    childPerPage += Math.floor(extraChild /
      (childWidth - parseInt(marginRight, 10) - parseInt(paddingRight, 10)));
    childPerPage = childPerPage || 1;
    const maxPage = Math.floor(this.childrenView.length / childPerPage) + ((this.childrenView.length % childPerPage) > 0 ? 1 : 0);
    // Resize carousel Wrapper height and scroller's width
    this.scroller.style.width = `${childPerPage * (maxPage + 1) * childWidth}px`;
    // if page is true then calculate maximum number of child view can fit in the each page and number of pages
    if (this.opts.scrollType === ScrollType.PAGE) {
      this.page.max = maxPage;

      // Need to update current: if resize happens and if childPerPage is different now
      if ((this.page.current > 1) && (this.page.childPerPage !== childPerPage)) {
        this.page.current = Math.floor(this.page.lastItemShown / childPerPage) + ((this.page.lastItemShown % childPerPage) > 0 ? 1 : 0);
      }

      // set new maximum page and child per page
      this.page.childPerPage = childPerPage;

      this.lastItemShown();
    } else {
      // else next/prev button move one element by one element
      this.page.max = this.childrenView.length - 1;
    }
  }

  /**
   * [EVENT LOGIC]
   * prevent unneeded event listener callback function to be call from parent
   */
  resizeEventListener() {}
}
